import { useEffect, useId, useState } from 'react';
import { ImagePlus, X } from 'lucide-react';
import './GalleryEditor.css';

let localKeyCounter = 0;
const nextKey = () => `new-${Date.now()}-${localKeyCounter++}`;

const resolveUrl = (path) =>
  path.startsWith('http') ? path : `${import.meta.env.VITE_API_URL}${path}`;

const Thumb = ({ item, onRemove }) => {
  const [src, setSrc] = useState(() => (item.imgPath ? resolveUrl(item.imgPath) : ''));

  useEffect(() => {
    if (!item.file) return undefined;
    const url = URL.createObjectURL(item.file);
    setSrc(url);
    return () => URL.revokeObjectURL(url);
  }, [item.file]);

  return (
    <div className={`gallery-editor__item ${item.file ? 'gallery-editor__item--new' : ''}`}>
      {src && <img src={src} alt="" className="gallery-editor__img" />}
      {item.file && <span className="gallery-editor__badge">Новое</span>}
      <button
        type="button"
        className="gallery-editor__remove"
        title="Убрать фото"
        onClick={onRemove}
      >
        <X size={14} />
      </button>
    </div>
  );
};

/**
 * Галерея фото: уже загруженные ({ key, imgPath }) и новые файлы ({ key, file }).
 * Ничего не отправляет сам — итоговый список уходит вместе с формой сущности.
 *
 * @param {Array} value
 * @param {Function} onChange
 */
export const GalleryEditor = ({ value = [], onChange }) => {
  const inputId = useId();

  const handleFiles = (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    if (!files.length) return;
    onChange([...value, ...files.map((file) => ({ key: nextKey(), file }))]);
  };

  return (
    <div className="gallery-editor">
      {value.map((item) => (
        <Thumb
          key={item.key}
          item={item}
          onRemove={() => onChange(value.filter((i) => i.key !== item.key))}
        />
      ))}
      <label htmlFor={inputId} className="gallery-editor__add">
        <ImagePlus size={22} strokeWidth={1.75} />
        <span>Добавить фото</span>
      </label>
      <input id={inputId} type="file" accept="image/*" multiple hidden onChange={handleFiles} />
    </div>
  );
};
